import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const TableService = {
  // Define your API functions here
  getList: async () => {
    const response = await apiService.get("/tables");
    return response.data;
  },
  create: async (postData) => {
    const response = await apiService.post("/tables", postData);
    return response.data;
  },

  detail: async (id) => {
    const response = await apiService.get(`/tables/${id}`);
    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(`/tables/${id}`);
    return response.data;
  },
  update: async (id, updatedData) => {
    try {
      const response = await apiService.put(`/tables/${id}`, updatedData);
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },

  switchTable: async (orderId, newTableId) => {
    try {
      const response = await apiService.put(
        `/order/change-table?orderId=${orderId}&newTableId=${newTableId}`
      );
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },

  switchItem: async (newTableId, data) => {
    try {
      const response = await apiService.put(
        `/order/switch-item-table?newTableId=${newTableId}`,
        data
      );
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },


  getStatusCount:async () => {
    const response = await apiService.get("/tables/status-counts");
    return response.data;
  },
};

export default TableService;
